// localStorage key for persisted org filters (legal entity + period), shared between the
// SARB Self-Assessment and Evidence Based Approach dashboard tabs.
export const ORG_FILTERS_STORAGE_KEY = 'rdarr-org-filters';
